<app-parcels-preview
  [noDataInfo]="noDataInfo"
  (onEdit)="showItemForm = true; parcelItemForm.patchValue($event.v); currentIndex = $event.i"
  (onRemove)="onRemoveItem($event)"
  [showActions]="!disabled"
  [canEdit]="(currentIndex === undefined) && !showItemForm"
  [parcels]="parcels()">
</app-parcels-preview>
@if (showItemForm) {
  <br>
  <div class="row">
    <div class="col-12">
      <app-parcel-item-form
        [edit]="currentIndex != undefined"
        [form]="parcelItemForm"
        (submit)="onSubmitItemForm($event)"
        (cancel)="onCancelItemForm()">
      </app-parcel-item-form>
    </div>
  </div>
}
<br>
<div class="row" *ngIf="!showItemForm && !disabled">
  <div class="col-12 d-flex justify-content-end">
    <button class="btn btn-primary" type="button" (click)="showItemForm = true">
      {{ parcels().length ? 'Dodaj kolejną działkę' : 'Dodaj działkę' }}
    </button>
  </div>
</div>
<br>
